

import React, { Component } from 'react';
import { useMediaQuery } from 'react-responsive'
// Externals
import compose from 'recompose/compose';

// Material helpers
import { withRouter } from 'react-router-dom';

import TableRow from '@material-ui/core/TableRow'
import TableCell from '@material-ui/core/TableCell'

// Material components
import PerfectScrollbar from 'react-perfect-scrollbar';
import Typography from '@material-ui/core/Typography';
import CircularProgress from '@material-ui/core/CircularProgress';
import Badge from "@material-ui/core/Badge";
import Button from '@material-ui/core/Button';
import styles from './styles';
import { withStyles } from '@material-ui/core/styles';
import StepsAvailability from '../stepsAvailability';
import Trend from '../Trend'
import ListItemText from '@material-ui/core/ListItemText';
import { withTranslation } from 'react-i18next';


// Component styles
import moment from 'moment'
import 'moment/locale/es'
moment.locale('es')
const dateMoment=((moment().locale('es')).format("dddd, MMMM YYYY, h:mm:ss a"))
const Desktop = ({ children }) => {
    const isDesktop = useMediaQuery({ minWidth: 1025 })
    return isDesktop ? children : null
  }
  const Tablet = ({ children }) => {
    const isTablet = useMediaQuery({ minWidth: 768, maxWidth: 991 })
    return isTablet ? children : null
  }
  const Mobile = ({ children }) => {
    const isMobile = useMediaQuery({ maxWidth: 767 })
    return isMobile ? children : null
  }
  const Default = ({ children }) => {
    const isNotMobile = useMediaQuery({ minWidth: 768 })
    return isNotMobile ? children : null
  }


class AvailabilityObjective extends Component {
    
    constructor(props) {
        super(props);
        this.state = {
            isLoad:true,
            listObjectivesJson:this.props.data,
            maxSteps:this.props.maxSteps,
            table:{},
            open: false,
            objNameModal: '',
        };
    }

    componentDidMount() {
        this.processData();
    }

    createCells(obj){
        const { classes } = this.props;
        const {maxSteps}= this.state
        let cells=[]
        if(obj.estado==="No monitoreo"){
            cells.push(<TableCell rowSpan={maxSteps} className={classes.td}></TableCell>)
        }else{
            {obj.Pasos.map(step=>(

                cells.push(
                
                    <StepsAvailability  step={step} objective={obj}/>)
            ))}
        }
        
        return cells
    }


    handleOpen = event => {       
        const objId = event.currentTarget.id
        const objName = event.currentTarget.value
        //console.log(objId, objName, this.state.open)
            this.setState({
                open: true,
                objIdModal: objId,
                objNameModal: objName
            })      
    };
    
    handleClose = event => {
        //const newStep = event.currentTarget.id
        this.setState({
            open: false,
        })
    };

    static getDerivedStateFromProps(props, state) {
        //console.log('derived', props.data, state.listObjectivesJson)
        if(props.data!==state.listObjectivesJson){
            return{
                listObjectives:[props.data.Downtime,props.data.Partial, props.data.Uptime],
            }
        }
        return null
    }

    processData = () => {
        //console.log("process")
        const {listObjectives, open, objIdModal, objNameModal}=this.state
        const {classes}=this.props
        this.setState({
            isLoad:false,
            //table:table
        })
        
    }

    getCellsObjective=(obj, key)=>{
        const {classes}=this.props
        var classInicio=classes.borderUptime
        var classColorObjective=classes.colorObjetivoUptime
        //console.log(obj.nombre_servicio_unificado)
        var classStyle=classes.atWeb
        if(obj.nombre_servicio_unificado==="atMobile"){
            classStyle=classes.atMobile
        }
        if(obj.nombre_servicio_unificado==="atIvr"){
            classStyle=classes.atIvr
        }
        obj["clase_badge"]=classStyle
        if(key==0){
            classInicio=classes.borderDowntime
            classColorObjective=classes.colorObjetivoDowntime
        }
        if(key===1){
            classInicio=classes.borderParcial
            classColorObjective=classes.colorObjetivoParcial
        }
        if(key===3){
            classInicio=classes.borderNoMon
            classColorObjective=classes.colorObjetivoNoMon
        }
        var table= <TableCell className={classInicio}>
                        <Button className={classes.ButtonObj} id={obj.objetivo_id} value={obj.nombre} onClick={this.props.handleOpen}>
                            <ListItemText
                                classes={{ primary: classes.listItemText }}
                                primary={obj.nombre}
                                //Cambia estructura, para agregar estilo custom directo
                                secondary={<div style={{ color: '#b2b2b2',  fontWeight: 'bold', }}>{obj.nombre_servicio_unificado}</div>}
                            />
                        </Button>
                    </TableCell>
        return table
    }
    

    render() {
        const listObjectives = [this.props.data.Downtime, this.props.data.Partial, this.props.data.Uptime, this.props.data.NoMonitoring, 
                                this.props.data.NoMonitoringPartial]
            
        const { isLoad, table, open,
            objIdModal,
            objNameModal, maxSteps} = this.state;
        const { classes } = this.props;

        const downtimeListOrder = [...(listObjectives[0] || [])]
        const partialListOrder = [...(listObjectives[1] || [])]
        const uptimeListOrder = [...(listObjectives[2] || [])]
        var noMonitoringPartialListOrder = []
        if (listObjectives[4]){
            noMonitoringPartialListOrder = [...listObjectives[4]]
        }
        var noMonitoringListOrder = []
        if (typeof(listObjectives[3]) != "undefined") {
            noMonitoringListOrder = [...listObjectives[3]]
        }
        let listObjectivesOrder = []
        downtimeListOrder.sort(function (a, b) {
            let nombreA = a.nombre.toLowerCase()
            let nombreB = b.nombre.toLowerCase()
            if (nombreA < nombreB) return -1;
            if (nombreA > nombreB) return 1;
            return 0;
        });
        partialListOrder.sort(function (a, b) {
            let nombreA = a.nombre.toLowerCase()
            let nombreB = b.nombre.toLowerCase()
            if (nombreA < nombreB) return -1;
            if (nombreA > nombreB) return 1;
            return 0;
        });
        uptimeListOrder.sort(function (a, b) {
            let nombreA = a.nombre.toLowerCase()
            let nombreB = b.nombre.toLowerCase()
            if (nombreA < nombreB) return -1;
            if (nombreA > nombreB) return 1;
            return 0;
        });
        noMonitoringListOrder.sort(function (a, b) {
            let nombreA = a.nombre.toLowerCase()
            let nombreB = b.nombre.toLowerCase()
            if (nombreA < nombreB) return -1;
            if (nombreA > nombreB) return 1;
            return 0;
        });
        noMonitoringPartialListOrder.sort(function (a, b) {
            let nombreA = a.nombre.toLowerCase()
            let nombreB = b.nombre.toLowerCase()
            if (nombreA < nombreB) return -1;
            if (nombreA > nombreB) return 1;
            return 0;
        });
        listObjectivesOrder = [downtimeListOrder, partialListOrder, uptimeListOrder, noMonitoringListOrder, noMonitoringPartialListOrder]
        const t = (this.props && this.props.t) ? this.props.t : (s => s)
        if (isLoad===true) {
            return(
                <TableCell className={classes.tdObjective}>
    
                        <Typography
                          variant="caption"
                          align="center"
                        >
                         <CircularProgress
                          variant="indeterminate"
    
                          size={12}
                          thickness={3}
                          
                        />
                         {t('text.loading')}
                       </Typography>
                </TableCell>
            )
        }else{
            //console.log('render table', listObjectives)
            return(
                listObjectivesOrder.map((ele, key)=>(
                    ele.map(obj=>(
                        <TableRow key={obj.objetivo_id}>
                            {this.getCellsObjective(obj, key)}
                            <TableCell className={classes.estado} style={{borderBottom: "4px solid #e4dede"}}></TableCell>
                            <TableCell colSpan={maxSteps}  style={{borderBottom: "4px solid #e4dede"}}>
                                <div style={{ overflowX: "auto", overflowY: "hidden", maxWidth: "100%", padding: "8px 0" }}>
                                    {this.createCells(obj)}
                                </div>
                            </TableCell>
                            {obj.estado==="No monitoreo"?
                            <TableCell style={{borderBottom: "4px solid #e4dede", width:"200px"}}></TableCell>
                            :
                            <TableCell style={{borderBottom: "4px solid #e4dede", width:"200px"}}>
                                <Trend data={obj} list={listObjectivesOrder}/>
                            </TableCell>
                            }
                            {obj.estado==="No monitoreo"?
                                <TableCell style={{borderBottom: "4px solid #e4dede", width:"200px", textAlign:"right"}}>
                                    <Typography variant="h6">{t('text.no-data')}</Typography>
                                </TableCell>
                                :
                                <TableCell style={{borderBottom: "4px solid #e4dede", textAlign:"right"}}>
                                    {obj.disponibilidad === undefined ?
                                    <Typography variant="h6">{t('text.no-data')}</Typography>
                                    :
                                    <Typography variant="h3" style={{color:"#616161"}}>{obj.disponibilidad} %
                                    </Typography>
                                    }
                                </TableCell>
                            }
                    </TableRow>
                    ))
                ))
            )
        }
        
        
    }
}



export default compose(withRouter, withStyles(styles), withTranslation())(AvailabilityObjective);